module.exports = __webpack_public_path__ + "static/media/icon_clock.fb1524f7.svg";